
import { Stack } from '@fluentui/react';
import { FluentProvider, webLightTheme, SkeletonItem } from '@fluentui/react-components';
import { dashboardTheme, notificationPosition, skeleton11 } from '../../styles/customStyles';

export const SkeletonNotifications = () => {
    return (
        <>
            <FluentProvider theme={dashboardTheme}>
                <Stack tokens={{ childrenGap: 15 }} style={notificationPosition}>
                    <SkeletonItem size={64} style={skeleton11} />
                    <SkeletonItem size={64} style={skeleton11} />
                    <SkeletonItem size={64} style={skeleton11} />
                    <SkeletonItem size={64} style={skeleton11} />
                    <SkeletonItem size={64} style={skeleton11} />
                    <SkeletonItem size={64} style={skeleton11} />
                    <SkeletonItem size={64} style={skeleton11} />
                </Stack>
            </FluentProvider>
        </>
    );
};